// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: var(--scrollbar-width);
  height: var(--scrollbar-width);
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--dialog-background-color);
  border-radius: var(--dialog-border-radius);
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--border-color); 
  border-radius: calc(var(--scrollbar-width) / 2);
  border: var(--scrollbar-padding) solid var(--dialog-background-color);
  min-height: calc(var(--scrollbar-width) * 3);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--dark-grey); 
}

::-webkit-scrollbar-corner {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/style/elements/scrollbars.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,qEAAqE;EACrE,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf","sourcesContent":["::-webkit-scrollbar {\n  width: var(--scrollbar-width);\n  height: var(--scrollbar-width);\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: var(--dialog-background-color);\n  border-radius: var(--dialog-border-radius);\n}\n \n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: var(--border-color); \n  border-radius: calc(var(--scrollbar-width) / 2);\n  border: var(--scrollbar-padding) solid var(--dialog-background-color);\n  min-height: calc(var(--scrollbar-width) * 3);\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: var(--dark-grey); \n}\n\n::-webkit-scrollbar-corner {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
